<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 40 40"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-243 -1492)"
      >
        <g>
          <path
            :fill="color"
            fill-rule="nonzero"
            d="M38.436 32.188c.863 0 1.562-.7 1.562-1.563v-1.63c0-3.71-3.018-6.728-6.728-6.728h-.962c.173-.49.269-1.015.269-1.563v-5.703c.863 0 1.562-.7 1.562-1.562V7.97c0-.863-.7-1.562-1.562-1.562H30.92c.52-1.323.436-2.864-.36-4.166-.655-1.068-1.685-1.818-2.902-2.11-1.218-.293-2.476-.094-3.544.56-.559.342-1.458 1.11-2.817 3.827l-.009.016-.008-.016c-1.359-2.717-2.259-3.485-2.817-3.827-1.068-.654-2.327-.853-3.544-.56-1.218.292-2.248 1.042-2.901 2.11-.798 1.302-.88 2.843-.362 4.166H10c-.863 0-1.563.7-1.563 1.562v5.469c0 .863.7 1.562 1.563 1.562v5.703c0 .288.027.57.077.844L7.95 19.603c-.891-.864-2.066-1.332-3.306-1.32-1.252.011-2.424.51-3.301 1.404C.465 20.58-.012 21.762 0 23.014c.012 1.252.51 2.424 1.404 3.301l.033.031 7.958 7.368c2.073 2.004 4.48 3.57 7.154 4.652C19.229 39.45 22.052 40 24.943 40h13.493c.863 0 1.562-.7 1.562-1.562 0-.863-.7-1.563-1.562-1.563H24.943c-5.024 0-9.779-1.924-13.388-5.419l-.025-.024-7.95-7.36c-.29-.291-.451-.677-.455-1.088-.004-.417.155-.81.447-1.109.293-.298.683-.464 1.1-.468h.016c.411 0 .8.159 1.094.448l.04.038 9.019 8.24c.857.927 2.081 1.508 3.44 1.508h7.812c.863 0 1.562-.7 1.562-1.562 0-.863-.7-1.563-1.562-1.563H18.28c-.323 0-.623-.098-.872-.266l-.027-.028-.318-.29c-.216-.268-.346-.608-.346-.978 0-.862.701-1.563 1.563-1.563h14.99c1.986 0 3.602 1.616 3.602 3.603v1.631c0 .863.7 1.563 1.563 1.563zm-8.984-11.484c0 .862-.701 1.562-1.563 1.562h-5.077v-7.265h6.64v5.703zm1.562-8.828h-8.202V9.532h8.202v2.344zm-6.929-5.948c1.091-2.183 1.64-2.558 1.66-2.571.357-.218.776-.284 1.182-.187.405.098.75.347.967.703.218.356.284.776.187 1.181-.098.406-.348.75-.702.967-.024.013-.608.33-3.051.3-.146-.002-.29-.005-.43-.01l.187-.383zm-9.402-2.055c.218-.356.56-.605.967-.703.122-.03.245-.044.368-.044.284 0 .564.078.811.23.023.014.571.389 1.662 2.572.065.13.127.258.188.384-.14.004-.285.007-.43.008-2.444.031-3.028-.286-3.05-.298-.356-.218-.605-.562-.703-.968-.098-.405-.031-.825.187-1.18zm-3.12 5.66h8.124v2.343h-8.125V9.532zM19.686 15v7.265h-5c-.862 0-1.562-.7-1.562-1.562v-5.703h6.562z"
            transform="translate(243 1492)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 40
    },
    variant: {
      type: String,
      default: 'light' // light, dark
    },
  },
  setup(props) {
    const color = (() => {
      if (props.variant === 'dark') {
        return '#303030'
      }
      if (props.variant === 'light') {
        return '#e5e5e5'
      }

      // Default: light
      return '#e5e5e5'
    })()

    const width = props.size
    const height = props.size

    return {
      color,
      width,
      height,
    }
  }
})
</script>
